import { render, staticRenderFns } from "./ReviewVacation.vue?vue&type=template&id=6451a3d6"
import script from "./ReviewVacation.vue?vue&type=script&lang=js"
export * from "./ReviewVacation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports